export default __webpack_public_path__ + "static/media/arrowLeft.870d72ab.svg";